import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import styled from './Theme';
const StyledSelect = styled(UISelect).withConfig({
  displayName: "SearchSelect__StyledSelect",
  componentId: "sc-1v0e3j-0"
})(["background-color:", " !important;"], props => props.theme.colors.OLAF);

const SearchSelect = (_ref) => {
  let {
    value,
    onChange
  } = _ref,
      inputProps = _objectWithoutPropertiesLoose(_ref, ["value", "onChange"]);

  const handleInputChange = useCallback(e => {
    if (!e.target.value) {
      onChange(null);
    }
  }, [onChange]);
  const handleSelectedOptionChange = useCallback(e => {
    onChange(e.target.value.value ? e.target.value : null);
  }, [onChange]);
  return /*#__PURE__*/_jsx(StyledSelect, Object.assign({
    anchorType: "button",
    value: value ? value.text : undefined,
    onSelectedOptionChange: handleSelectedOptionChange,
    onInputValueChange: handleInputChange
  }, inputProps));
};

export default SearchSelect;